class Modal {
    _domId = '';
    _instance = '';
    _domInstance = null;
    _options = {}
    _info = {}

    /**
     * 
     * @param {object} props 
     * @param {string} props.domId
     * @param {object} props.options
     */
    constructor(props) {
        this._domId = props.domId || ''
        this._options = props.options || {}
        this._domInstance = document.getElementById(this._domId);
        this.init();
    }
    init = () => {
        try {
            this._instance = new bootstrap.Modal(this._domInstance, this._options);
            this._domInstance.addEventListener('hide.bs.modal', this.onClose)
            this._domInstance.addEventListener('show.bs.modal', this.onOpen)
        } catch (error) {
            console.error(error);
        }
    }

    onOpen = (event) => {
    }
    onClose = (event) => {

    }
    onSubmit = async (info) => {
        const data = {
            resourceId: info.resource.id,
            start: info.date,
            end: info.date,
        }
        this.postData(data).then(() => {

            //TODO: close dialog 

        })


    }


    open = (info) => {
        try {

            this._info = info;
            // console.log("info:");
            var startDate = document.getElementById(this._options.startId)
            var startHour = document.getElementById(this._options.startHourId)
            var dialogFields = document.getElementById(this._options.fieldsId)
            document.getElementById("DialogField3").value = info.booking.createdBy.userName

            // console.log(info);
            // console.log(info.jsEvent);
            // console.log(info.jsEvent.type);



            if (info.jsEvent.type == 'mouseup') {
                // console.log("no");
                var date = info.dateStr.split("T")
                var fieldName = info.resource.id
                startDate.value = date[0]
                startHour.value = (date[1].split(":00Z")[0]).toString()
                // console.log(date)

                dialogFields.value = fieldName

            } else if (info.jsEvent.type == 'click') {
                // console.log("yes");

                //info.event.id
                // console.log(info.event.start)
                var date = info.event.start.toISOString().split("T")
                var fieldName = info.event._def.resourceIds[0]

                startDate.value = date[0]
                startHour.value = (date[1].split(":00.000Z")[0]).toString()
                dialogFields.value = fieldName
                //  console.log(date)
                document.getElementById("hiddenId").value = info.event.id
                var event = new Event('change');
                document.getElementById("hiddenId").dispatchEvent(event);
            }
        } catch (e) {
            console.error(e);
        }
        try {
            var event = new Event('change');
            startHour.dispatchEvent(event);
            startDate.dispatchEvent(event);
            dialogFields.dispatchEvent(event);
        } catch (e) {
            console.error(e);

        }
        this._instance.show()
    }
    close = () => {

        this._instance.hide()




    }
    postData = async (data) => {

        (async () => {
            const rawResponse = await fetch('/api/Bookings', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            const content = await rawResponse.json();
            // this.refetchEvents();
            window.location.reload();
        })();


    }
}
export { Modal }